export default __webpack_public_path__ + "static/media/property_314.df581abc.png";